import Logo from "@assets/icons/voxtox_alt.svg";
import { Card } from "@components/Layout";
import { OverlayLogo } from "./styled";

const LoadingOverlay = () => {
	return (
		<Card w="100dvw" h="100dvh" alignItems="center" justifyContent="center">
			<OverlayLogo alt="logo" src={Logo} />
		</Card>
	);
};
export default LoadingOverlay;
